import React from 'react';
import EducatorsHomeContainer from '@src/containers/EducatorsHome';

const EducatorsHome = () => <EducatorsHomeContainer />;

export default EducatorsHome;
